import customConfig from 'src/config';
import { isInUIC } from '@Utils/common';

function getCookieForOf(name) {
  const nameEQ = name + '=';
  for (const cookie of document.cookie.split('; ')) {
    if (cookie.indexOf(nameEQ) === 0) {
      const value = cookie.substring(nameEQ.length);
      return decodeURIComponent(value); // returns first found cookie
    }
  }
  return null;
}

/**
 * @param {string} event
 * @param {boolean} flush
 */
export function reportPendo(trackType, metadata, flush = true) {
  if (pendo) {
    pendo.track(trackType, metadata);
    if (flush) {
      pendo.flushNow();
    }
  }
}

let pendoInitFlag = false;

export default () => {
  const pendoApiKey = customConfig.ui.pendoApiKey;
  let visitorId = sessionStorage.getItem('visitor_id');
  let accountId = sessionStorage.getItem('account_id');
  if (isInUIC()) {
    visitorId = localStorage.getItem('uic_userGUID');
    accountId = localStorage.getItem('uic_companyGUID');
  }
  if (!pendoApiKey || pendoInitFlag) return;

  (function (apiKey) {
    (function (p, e, n, d, o) {
      let v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = [];
      v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];
      for (w = 0, x = v.length; w < x; ++w) {
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? 'unshift' : 'push'](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      }
      y = e.createElement(n);
      y.async = !0;
      y.src =
        'https://content.analytics.trendmicro.com/agent/static/' +
        apiKey +
        '/pendo.js';
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
  })(pendoApiKey);

  const pendoInitTimeOut = setInterval(() => {
    // No 'login_type' cookie, not logined, do not install
    if (!visitorId || !accountId) {
      return;
    }
    clearInterval(pendoInitTimeOut);
    pendo.initialize({
      visitor: {
        id: visitorId,
      },
      account: {
        id: accountId,
      },
      guideTimeout: Number(sessionStorage.getItem('guideTimeout')) || 20000,
      events: {
        guidesFailed() {
          pendo.track('Failed to Load Guides', {
            visitor_id: visitorId,
            account_id: accountId,
            url: pendo.getCurrentUrl(),
            userAgent: window.navigator.userAgent,
          });
        },
      },
    });
    pendoInitFlag = true;
  }, 500);
};
